/**
 @Developper: BenAli Faker
 @Company: SMART-INFO
 @Post: CTO
 @Date:17/12/2021
 @Time:13:55
 **/
class GoogleRecaptchaService {

    #_siteKey;

    /**
     * Not attached forms
     * @type {[{}]}
     */
    #_notAttachedFormsStack = [];

    /**
     * @type boolean
     */
    #_apiGoogleIsLoaded = false;

    /**
     * Attach google recaptcha to a form
     *
     * @param {string}selector
     * @param action
     */
    attachRecaptchaToForm(selector, action) {
        this.#_loadGoogleApiScript();
        let form = $(selector);
        let recaptchaService = this;
        if (!this.#_apiGoogleIsLoaded) // api is not yet loaded we delay recpatcha token injection
        {
            this.#_notAttachedFormsStack.push({selector: selector, action: action});
        }else { //google recaptcha api script is loaded
            grecaptcha.ready(function() {
                let token_injected=false;//inject the token when submit form to avoid time exceed error launched by google
                form.submit(function(event)
                {
                    if(!token_injected) {
                        grecaptcha.execute(recaptchaService.#_siteKey, {action: action}).then(function (response) {
                            if (form.find("#g-recaptcha-response").length === 0) {
                                form.prepend($("<input/>").attr(
                                    {
                                        "id": "g-recaptcha-response",
                                        "type": "hidden",
                                        "name": "g-recaptcha-response",
                                        "value":response
                                    }
                                ));
                            }
                            token_injected=true;
                            form.find(":submit").trigger('click');//form.submit() not work we must re-submit manually form by trigger manually click on submit button
                        });
                        return false;
                    }
                });
            });

        }
    }

    /**
     * load google script api if already not loaded
     * @private
     */
    #_loadGoogleApiScript() {
        let captchaService=this;
        if (!this.#_apiGoogleIsLoaded) {
            let siteKey = this.#_siteKey
            if (siteKey === null) {
                Begro.logError("Google site key is not defined !")
            } else {
                $.getScript(`https://www.google.com/recaptcha/api.js?render=${siteKey}`, function () {
                    Begro.logInfo("google recaptcha api loaded successfully!");
                    captchaService.#_apiGoogleIsLoaded = true;
                    Begro.logInfo("Execution delayed Forms google recaptcha token injection")
                    for(let i in captchaService.#_notAttachedFormsStack)
                    {
                        let formToAttachData=captchaService.#_notAttachedFormsStack[i];
                        Begro.logInfo("--Delayed form :"+formToAttachData.selector);
                        captchaService.attachRecaptchaToForm(formToAttachData.selector,formToAttachData.action);
                    }
                    captchaService.#_notAttachedFormsStack=[];//initialize array
                });
            }
        }
    }


    /**
     * set google site key
     * @param value
     */
    set siteKey(value) {
        this.#_siteKey = value;
    }
}

const googleRecaptchaService = new GoogleRecaptchaService();
Object.freeze(googleRecaptchaService);
export default googleRecaptchaService;
